import React, { createContext, useContext, useState, ReactNode } from 'react';

interface HeaderActionsContextType {
  actions: ReactNode | null;
  setActions: (actions: ReactNode | null) => void;
}

const HeaderActionsContext = createContext<HeaderActionsContextType | undefined>(undefined);

export const HeaderActionsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [actions, setActions] = useState<ReactNode | null>(null);

  return (
    <HeaderActionsContext.Provider value={{ actions, setActions }}>
      {children}
    </HeaderActionsContext.Provider>
  );
};

export const useHeaderActions = () => {
  const context = useContext(HeaderActionsContext);
  if (!context) {
    throw new Error('useHeaderActions must be used within a HeaderActionsProvider');
  }
  return context;
};

// Hook to set header actions - cleans up on unmount
export const useSetHeaderActions = (actions: ReactNode) => {
  const { setActions } = useHeaderActions();
  
  React.useEffect(() => {
    setActions(actions);
    return () => setActions(null);
  }, [actions, setActions]);
};

